import { GQLResponseServerError } from '@change-corgi/core/gql';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { LoginByOtp, type LoginByOtpMutation, type LoginByOtpMutationVariables } from './loginByOtp.graphql';

export type LoginByOtpResponse = LoginByOtpMutation['loginByOtp'];

export async function loginByOtp(
	input: LoginByOtpMutationVariables['input'],
	{ gql: { fetch } }: UtilityContext,
): Promise<LoginByOtpResponse> {
	try {
		const { data } = await fetch<LoginByOtpMutation, LoginByOtpMutationVariables>({
			path: '/login',
			query: LoginByOtp,
			variables: { input },
			rejectOnError: true,
			batched: false, // to ensure this rate limited mutation is not batched
		});
		if (!data) throw new Error('No data returned from query.');
		return data.loginByOtp;
	} catch (error) {
		if (error instanceof GQLResponseServerError) {
			if (error.status === 429) {
				return { status: 'RATE_LIMITED' };
			}
		}
		throw error;
	}
}
